import React, {useEffect} from "react";
import {AppStatus} from "./App";
import classes from "./Timer.module.css";

type Props = {
    appStatus: AppStatus
    setClickCount: (count: number) => void
    countRef:  React.RefObject<HTMLDivElement>
}

let timeoutID: NodeJS.Timeout;
let startTime: number;
let stopTime = 0;

export const Timer = ({appStatus, setClickCount, countRef}: Props) => {

    useEffect(() => {
        if (appStatus === "run") {
            startTime = Date.now();
            displayTime();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appStatus])

    useEffect(() => {
        if (appStatus === "result" || appStatus === "waitingResult") {
            clearTimeout(timeoutID);
            stopTime += (Date.now() - startTime);
        }
    }, [appStatus])

    useEffect(() => {
        if (appStatus === "ready") {
            const time = document.getElementById('time')! as HTMLElement;
            time.innerText = '00分00秒';
            stopTime = 0;
            setClickCount(0)
        }
    }, [appStatus, setClickCount])


    function displayTime() {
        const time = document.getElementById('time')! as HTMLElement;

        const penaltyTime = countRef.current !== undefined ? Number(countRef.current?.innerText.slice(0,-2)) * 10 : 0
        let currentTime = new Date(Date.now() - startTime + stopTime);
        currentTime.setSeconds(currentTime.getSeconds()+ penaltyTime)

        const h = String(currentTime.getHours() - 9).padStart(2, '0');
        const m = String(currentTime.getMinutes()).padStart(2, '0');
        const s = String(currentTime.getSeconds()).padStart(2, '0');
        const ms = String(currentTime.getMilliseconds()).padStart(2, '0').slice(0, 2);

        if (h === "00" && m === "00") {
            time.innerText = `${s}秒${ms}`
        } else if (h === "00") {
            time.innerText = `${m}分${s}秒${ms}`
        } else {
            time.innerText = `${h}時間\n${m}分${s}秒${ms}`
        }

        timeoutID = setTimeout(displayTime, 10);
    }

    return (
        <div>
            <div className={classes.timerTitle} id="timeText">タイム</div>
            <div className={classes.time} id="time">00分00秒</div>
        </div>
    )
}